module.exports = __webpack_public_path__ + "static/media/img_6.bc0ac95c.png";